import {
  type ComponentPropsWithoutRef,
  Suspense,
  useEffect,
  useReducer
} from 'react';

export function useIsHydrated() {
  const [isHydrated, hydrate] = useReducer(() => true, false);

  useEffect(() => {
    hydrate();
  }, []);

  return isHydrated;
}

export function ClientSuspense(
  props: ComponentPropsWithoutRef<typeof Suspense>
) {
  const isHydrated = useIsHydrated();

  return (
    <Suspense {...props}>
      {isHydrated ? props.children : props.fallback}
    </Suspense>
  );
}
